<h2 mat-dialog-title>
  <ng-container [ngSwitch]="formMode">
    <ng-container *ngSwitchCase="'forgot'">{{ 'LOGIN.FORGOT_PASSWORD' | translate }}</ng-container>
    <ng-container *ngSwitchCase="'reset'">{{ 'PW.RESET_PW' | translate }}</ng-container>
    <ng-container *ngSwitchCase="'change'">{{ 'PW.CHANGE_PW' | translate }}</ng-container>
  </ng-container>
</h2>

<form [formGroup]="pwForm" (ngSubmit)="onSubmit()">
  <mat-dialog-content>
    <mat-form-field>
      <mat-label>{{ 'EMAIL' | translate }}</mat-label>
      <input matInput type="email" required formControlName="email" [email]="true" maxlength="255" autocomplete="username" />
    </mat-form-field>
    <mat-form-field *ngIf="formMode === 'change'">
      <mat-label>{{ 'PW.CURRENT_PW' | translate }}</mat-label>
      <input matInput type="password" required formControlName="currentPassword" #txtCurrentPassword autocomplete="current-password" />
    </mat-form-field>
    <mat-form-field *ngIf="formMode === 'reset' || formMode === 'change'">
      <mat-label>{{ 'PW.NEW_PW' | translate }}</mat-label>
      <input matInput type="password" required formControlName="newPassword" minlength="6" #txtNewPassword autocomplete="new-password" />
      <mat-error *ngIf="pwForm.controls.newPassword.hasError('minlength')">{{ 'INPUT.MIN_LENGTH' | translate : { n: 6 } }}</mat-error>
    </mat-form-field>
    <mat-form-field *ngIf="formMode === 'reset' || formMode === 'change'">
      <mat-label>{{ 'PW.NEW_PW_REPEAT' | translate }}</mat-label>
      <input
        matInput
        type="password"
        formControlName="newPasswordConfirm"
        [errorStateMatcher]="pwRepeatMatcher"
        autocomplete="new-password"
      />
      <mat-error *ngIf="pwForm.hasError('notSame')">{{ 'PW.PW_REPEAT_INVALID' | translate }}</mat-error>
    </mat-form-field>

    <div *ngIf="pwForm.errors && !pwForm.errors['notSame']">
      <mat-error *ngIf="pwForm.hasError('serverError')" class="pre-line">{{ pwForm.errors['serverError'] }}</mat-error>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button type="button" mat-button mat-dialog-close>{{ 'CANCEL' | translate }}</button>
    <button type="submit" mat-raised-button color="primary" [disabled]="!pwForm.valid || isSubmitting" #btnSubmit>
      {{ (formMode === 'forgot' ? 'PW.SEND_RESET_LINK' : 'PW.CHANGE_PW') | translate }}
    </button>
  </mat-dialog-actions>
</form>
